import React from "react";
import { Modal } from "react-bootstrap";
import classes from "./ModalSkeleton.module.css";
import { AiOutlineClose } from "react-icons/ai";
import Classes from "./ModalSkeleton.module.css";
export default function ModalSkeleton({
  show,
  setShow,
  header,
  footer,
  children,
  modalClass,
  hideHeaderBorder,
  headerStyles,
  footerStyles,
  borderRadius,
  showCloseIcon,
  width = "644px",
  borderLine = true,
  headerClass,
  bodyPadding = "24px",
}) {
  function handleClose() {
    setShow(false);
  }
  return (
    <>
      <style>{`
        .modal-header {
          border-bottom: ${!borderLine && "none !important"};
          padding-bottom: ${!borderLine && "0 !important"};
        }
        .modal-header {
          border-bottom: ${
            hideHeaderBorder ? "none" : `1px solid var(--main-color-yellow)`
          };
        }
        .modal-footer {
          margin: 0px;
          display: unset;
          justify-content: unset;
          align-items: unset;
          padding: ${!borderLine ? "15px 30px" : "0px"};
        }

        .${classes.header} button {
          color: var(--black-color) !important;
        }
        .modal-content {
          width: 94%;
          border-radius: ${borderRadius ? borderRadius : "16px"};
          margin: 0 auto;
          background-color:var(--white-color);
        }
        .modal .modal-dialog {
          max-width: ${width} !important;
          margin: 0px auto;
        }
        .modal-header{
          padding:24px;
        }
        .modal-body{
          padding: ${bodyPadding}

        }
      `}</style>

      <Modal
        show={show}
        onHide={handleClose}
        centered
        className={`${[classes.modal].join(" ")}`}
      >
        {header && (
          <Modal.Header
            closeButton
            className={`${[classes.header, headerClass && headerClass].join(
              " "
            )}`}
            style={{ ...headerStyles }}
          >
            <h2 className={["fw-600 lh-38", Classes.heading].join(" ")}>
              {" "}
              {header}
            </h2>
          </Modal.Header>
        )}
        {showCloseIcon && (
          <div className={classes.iconBox} onClick={handleClose}>
            <AiOutlineClose size={20} />
          </div>
        )}
        <Modal.Body
          className={`${[classes.body, modalClass && modalClass].join(" ")}`}
        >
          {children}
        </Modal.Body>
        {footer && (
          <Modal.Footer
            className={`${[classes.footer].join(" ")}`}
            style={{
              //   borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
              ...footerStyles,
            }}
          >
            <div>{footer}</div>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
}
